import './Watermark.scss'
import React from 'react'

export const Watermark = () => <div className="watermark" />;